// LIL Choklet Lab Home section
const chokletHome = document.querySelector(".chokletlab-home");

if (chokletHome != null) {
  const slider = document.getElementById("chokletlab-slider");

  const leftArrow = document.querySelector(".left");
  const rightArrow = document.querySelector(".right");
  const indicatorParent = document.querySelector(".chokletlab-slider-nav");
  const infoParent = document.querySelector(".chokletlab-slider-info");
  let sliderIndex = 0;

  function setSlider() {
    document.querySelector(".chokletlab-slider-nav .lil-pill-selected").classList.remove("lil-pill-selected");
    document.querySelectorAll(".chokletlab-slider-info .slide-info").forEach((item) => { item.classList.remove("current-info") });
  }

  document.querySelectorAll(".lil-pill-button").forEach((indicator, index) => {
    indicator.addEventListener("click", () => {
      sliderIndex = index;
      setSlider();

      slider.style.transform = "translateX(" + (sliderIndex) * -33.33 + "%)";

      indicatorParent.children[sliderIndex].classList.add("lil-pill-selected");
      infoParent.children[sliderIndex].classList.add("current-info");

      indicator.classList.add("lil-pill-selected");
    });
  });

  leftArrow.addEventListener('click', () => {
    sliderIndex = (sliderIndex > 0) ? sliderIndex - 1 : 0;
    setSlider();

    slider.style.transform = "translateX(" + (sliderIndex) * -33.33 + "%)";

    indicatorParent.children[sliderIndex].classList.add("lil-pill-selected");
    infoParent.children[sliderIndex].classList.add("current-info");
  });

  rightArrow.addEventListener('click', () => {
    sliderIndex = (sliderIndex < 2) ? sliderIndex + 1 : 2;
    setSlider();

    slider.style.transform = "translateX(" + (sliderIndex) * -33.33 + "%)";

    indicatorParent.children[sliderIndex].classList.add("lil-pill-selected");
    infoParent.children[sliderIndex].classList.add("current-info");
  });
}

// Home Reviews slider
const reviews = document.getElementById("lil-home-reviews");
if (reviews != null) {
  const swiper = new Swiper('#lil-home-reviews', {
    // Optional parameters
    loop: true,
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 100,
      },
      940: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 15,
      },
    },
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}


// Collection page: Read more button if the Seo description has an overflow (aka longer than 7 lines)
let readMore = document.getElementById("seo-read-more");
const seoDescription = document.getElementById("collection-seo-description");
const ifPinjected = document.querySelector("#collection-seo-description p");
const ifSpanInjected = document.querySelector("#collection-seo-description span");

function trimCollectionText(el) {
  if (el != null) {
    let elHeight = el.offsetHeight;

    if (elHeight > 70) {
      el.classList.add("collapsed");
      readMore.style.visibility = "visible";

      readMore.addEventListener("click", () => {
        el.classList.toggle("collapsed");

        if (!el.classList.contains("collapsed")) {
          readMore.innerHTML = readMore.dataset.less || "collapse";
        } else {
          readMore.innerHTML = readMore.dataset.more || "read more";
        }
      });
    }
  }
}

if (seoDescription != null) {
  trimCollectionText(seoDescription);
}
if (ifPinjected != null) {
  trimCollectionText(ifPinjected);
}
if (ifSpanInjected != null) {
  trimCollectionText(ifSpanInjected);
}

// About page "gif"
const gifImages = Array.from(document.querySelectorAll(".lil-gif > img"));

if (gifImages != []) {
  // single gifImages src
  var frames = gifImages.map((img) => {
    return img.src;
  });

  // single gifImages srcsets
  var srcSets = gifImages.map((img) => {
    return img.srcset;
  });

  // I get the first one (to set it display block because in css it's display none)
  var firstImage = gifImages[0];

  // setting the index
  var currentFrame = 0;

  function start() {
    setTimeout(function () {
      if (firstImage != null) {
        firstImage.style.display = "block";



        //changing first image src + srcset
        firstImage.src = frames[currentFrame];
        firstImage.srcset = srcSets[currentFrame];

        currentFrame++;

        // looping the index
        if (currentFrame >= gifImages.length) {
          currentFrame = 0;
        }

        start();
      }

    }, 500);
  }

  start();
}

// About scroll blocks (1)
const aboutStickySection = document.querySelector(".about-sticky-section");

if (aboutStickySection != null) {
  let imgs = gsap.utils.toArray('.scroll-image');
  let textBlocks = gsap.utils.toArray('.textblock');

  const height = 100 * textBlocks.length + 80;

  const tl = gsap.timeline({
    duration: imgs.length,
    scrollTrigger: {
      trigger: ".about-sticky-section",
      start: "top top",
      end: "+=" + height + "%",
      scrub: true,
      id: "imgs",
    }
  });

  const pinner = gsap.timeline({
    scrollTrigger: {
      trigger: ".about-sticky-section",
      start: "top-=80px top",
      end: "+=" + height + "%",
      scrub: true,
      pin: ".about-one-gsap-scroll",
      id: "pinning"
    }
  });
  // Animazione immagini
  imgs.forEach((elem, i) => {
    gsap.set(elem, { position: "absolute", top: 0, left: 0, width: "100%" });
    tl.from(elem, { autoAlpha: 0 }, i)

    if (i != imgs.length - 1) {
      tl.to(elem, { autoAlpha: 0 }, i + 0.75)
    }
  });
  // Animazione testi
  textBlocks.forEach((elem, i) => {
    gsap.set(elem, { position: "sticky", top: 0 });
    tl.from(elem, { y: 700 }, i)

    if (i != imgs.length - 1) {
      tl.to(elem, { y: 0 }, i + 0.75)
    }
  });
}

// Lil Charity change color
const charitySection = document.querySelector(".lil-charity");
const charityColorTrigger = document.querySelector(".charity-trigger");

if (charitySection != null) {
  const observer = new window.IntersectionObserver(([elem]) => {
    if (elem.isIntersecting) {
      charitySection.classList.add("color-transition");
      return
    }
    charitySection.classList.remove("color-transition");
  }, {
    root: null,
    threshold: 0.5,
  });

  observer.observe(charityColorTrigger);

  // About scroll blocks (2) -- charity
  let money = gsap.utils.toArray('.charity-money');
  let circleCol = gsap.utils.toArray('.circle-wrapper');

  const charityHeight = 100 * circleCol.length;

  const charityTl = gsap.timeline({
    duration: circleCol.length,
    scrollTrigger: {
      trigger: ".charity-trigger",
      start: "top top",
      end: "+=" + charityHeight + "%",
      scrub: true,
      id: "charity",
    }
  });

  const charityPinner = gsap.timeline({
    scrollTrigger: {
      trigger: ".charity-trigger",
      start: "top top",
      end: "+=" + charityHeight + "%",
      scrub: true,
      pin: ".charity-trigger",
      id: "pinning"
    }
  });

  money.forEach((elem, i) => {
    charityTl.from(elem, { y: 200, autoAlpha: 0 }, i)

    if (i != money.length - 1) {
      charityTl.to(elem, { y: 0, autoAlpha: 0 }, i + 0.75)
    }
  });

  const indicators = Array.from(document.querySelectorAll(".indicator"));
  indicators.forEach((el, index) => {
    el.innerHTML = index + 1 + "/" + indicators.length;
  });

  circleCol.forEach((elem, i) => {
    charityTl.from(elem, { autoAlpha: 0 }, i)

    if (i != circleCol.length - 1) {
      charityTl.to(elem, { autoAlpha: 0 }, i + 0.75);
    }
  });
}


//Lil anchor links -- The brand - About page
const stickyLinks = document.querySelector(".lil-anchor-links");

if (stickyLinks != null) {
  document.addEventListener("scroll", () => {
    const scroll = (window.pageYOffset || document.scrollTop) - (document.clientTop || 0);

    if (window.pageYOffset === 0) {
      stickyLinks.classList.remove("sticky-links");
    }

    if (scroll > window.outerHeight) {
      stickyLinks.classList.add("sticky-links");
    } else {
      stickyLinks.classList.remove("sticky-links");
    }
  });

  let pills = document.querySelectorAll(".anchor-links > li");

  function RemoveSettedPill() {
    pills.forEach((pill) => {
      pill.classList.remove("lil-pill-selected");
    })
  }

  pills.forEach((pill) => {
    const a = pill.href;

    pill.addEventListener("click", () => {
      if (!pill.classList.contains("lil-pill-selected")) {
        RemoveSettedPill();
        pill.classList.add("lil-pill-selected");
      }
    });
  });
}



//LIL Header change findus
const country = localStorage.getItem('lil-customer-country');
const findUsAll = document.querySelectorAll('.findus-link');

if (country == "GB") {
  findUsAll.forEach((findus) => {
    findus.href = findus.dataset.enUrl;
  });
} else {
  findUsAll.forEach((findus) => {
    findus.href = findus.dataset.itUrl;
  });
}


//LIL Footer change company
let companyIt = document.getElementById("company-it");
let companyUk = document.getElementById("company-uk");

if (country == "GB") {
  companyUk.style.display = "block";
  companyIt.style.display = "none";
} else {
  companyIt.style.display = "block";
  companyUk.style.display = "none";
}


// Press Slider
// Sliders init
function initSwiper(sliderElm) {
  const identifier = sliderElm.dataset.id;
  return new Swiper(`#${sliderElm.id}`, {
    loop: true,
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 100,
      },
      940: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 15,
      },
    },
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  });
}

let allSliders = document.querySelectorAll('.lil-press');
allSliders.forEach((slider) => {
  initSwiper(slider);
});


// Horoscope
let zodiac = document.querySelectorAll(".horoscope");
zodiac.forEach((sign) => {
  toggleModal(sign);
});

function toggleModal(el) {
  const sign = el.dataset.id;

  el.addEventListener("click", (e) => {
    e.preventDefault();
    let modalSign = document.querySelectorAll(".horoscope-modal");

    modalSign.forEach((modal) => {
      if (modal.classList.contains("horoscope-modal--" + sign)) {
        modal.classList.toggle("is-visible");
      }
    });
  });
}

// LIL Astro Read Horoscope
const horoscopeBtn = document.getElementById("read-horoscope");
if (horoscopeBtn != null) {
  horoscopeBtn.addEventListener("click", () => {
    scrollBottom(700);
  });
}

// LIL Astro gradient
/*
const astroGradient = document.querySelector(".light-gradient-fade");
if (astroGradient != null) {
    document.addEventListener("scroll", () => {
        if (window.pageYOffset >= 200) {
            astroGradient.classList.add("gradient-is-in");
        } else {
            astroGradient.classList.remove("gradient-is-in");
        }
    });
}*/

//Diamond guide scroll
const diamondScroll = document.getElementById("diamond-scroll");
if (diamondScroll != null) {
  diamondScroll.addEventListener("click", () => {
    scrollBottom(700);
  });
}

function scrollBottom(value) {
  window.scrollTo({
    top: value,
    left: 0,
    behavior: 'smooth'
  });
}

//Diamond guide main funcionality
const dgPills = document.querySelectorAll(".diamondguide-buttons .lil-pill-button");
const dgBlocks = document.querySelectorAll(".dg-block");

if (dgBlocks != null) {
  function setClass(arr, cl) {
    arr.forEach((e) => {
      e.classList.remove(cl);
    });
  }

  dgPills.forEach((pill) => {
    pill.addEventListener("click", () => {
      setClass(dgPills, "lil-pill-selected");
      pill.classList.add("lil-pill-selected");

      dgBlocks.forEach((block) => {
        if (pill.id == block.id) {
          setClass(dgBlocks, "block-current");
          block.classList.add("block-current");
        }
      });
    });
  });

  //Diamond guide cut change photo
  const cutButtons = document.querySelectorAll(".cut-img");
  const cutMainImage = document.getElementById("image-for-cut");

  cutButtons.forEach((button) => {
    button.addEventListener("click", () => {
      setClass(cutButtons, "current");
      button.classList.add("current");

      if (button.classList.contains("current")) {
        let currentButton = button;
        cutMainImage.src = currentButton.dataset.image;
      }
    });
  });
}

//Multi video hero
const videoThumbs = document.querySelectorAll(".multivideo-hero .thumbnail-wrapper");
const currentVideo = document.querySelector(".multivideo-hero .hero-video");
const currentThumb = document.querySelector(".multivideo-hero .thumbnail-wrapper.current");

if (currentThumb != null) {

  function prepareClass(array) {
    array.forEach((el) => {
      el.classList.remove("current");
    });
  }

  videoThumbs.forEach((element) => {
    element.addEventListener("click", () => {
      prepareClass(videoThumbs);
      element.classList.add("current");
      currentVideo.src = 'https://player.vimeo.com/video/' + element.dataset.id + '?muted=1&controls=0&autoplay=1&loop=1';
    });
  });
}

// Product page restart Geo Popup
var geoHint = document.getElementById("geo-hint");

if (geoHint != null) {
  geoHint.addEventListener('click', () => {
    popup.classList.remove('d-none');
  });
}

// Sticky product page form
jQuery(document).ready(function () {
  function resizeStickyForm() {
    var stickyProductInfo = document.querySelector(".product-wrapper .info-box");
    var width = (window.innerWidth > 0) ? window.innerWidth : document.documentElement.clientWidth;
    if (width > 1024) {
      if (stickyProductInfo != null) {
        document.addEventListener("scroll", () => {
          if (window.pageYOffset >= 650) {
            stickyProductInfo.style.top = "-180px";
          } else if (window.pageYOffset > 900) {
            stickyProductInfo.style.top = "-400px";
          } else if (window.pageYOffset == 0) {
            stickyProductInfo.style.top = "120px";
          }
        });
      }
    } else {
      //nothing
    }
  }
  window.onresize = resizeStickyForm;
  resizeStickyForm();
});

// Market selector
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);


// Collection Slider (for BTC)
// Home Reviews slider
const collectionSlider = document.querySelector(".lil-collection-slider");
if (collectionSlider != null) {
  const swiper = new Swiper('#lil-swiper-collection', {
    // Optional parameters
    loop: true,
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 100,
      },
      940: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 15,
      },
    },
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}

//BTC password
const btcButton = document.getElementById("btc-submit");

//BTC member page variables
const btcPills = document.querySelectorAll(".btc-content-buttons .lil-pill-button");
const btcBlocks = document.querySelectorAll(".btc-block");

// Exit button
const exitButton = document.getElementById("member-exit");

// Elements
const landingElements = document.querySelectorAll("[data-display='landing']");
const memberElements = document.querySelectorAll("[data-display='club']");

if (landingElements != null || memberElements != null || landingHero != null) {
  const userPassword = document.getElementById("btc-password");
  const formError = document.getElementById("incorrect-password");

  //Session Check
  sessionCheck();

  //Password click enter on input
  if (userPassword != null) {
    userPassword.addEventListener("keyup", function (e) {
      if (e.code === 'Enter') {
        btcButton.click();
      }
    });
  }


  //Member session check
  function sessionCheck() {
    if (localStorage.getItem('btcMember') == "true") {
      landingElements.forEach(element => {
        element.style.display = "none";
      });

      memberElements.forEach(element => {
        element.style.display = "block";
      });
    } else if (localStorage.getItem('btcMember') == "false") {
      landingElements.forEach(element => {
        if (element.classList.contains("lil-btc-hero")) {
          element.style.display = "flex";
        } else {
          element.style.display = "block";
        }
      });

      memberElements.forEach(element => {
        element.style.display = "none";
      });
    } else if (localStorage.getItem('btcMember') == null) {
      landingElements.forEach(element => {
        if (element.classList.contains("lil-btc-hero")) {
          element.style.display = "flex";
        } else {
          element.style.display = "block";
        }
      });

      memberElements.forEach(element => {
        element.style.display = "none";
      });
    }
  }

  //Save Member
  function saveMember() {
    localStorage.setItem('btcMember', true);
  }

  //Submit password
  if (btcButton != null) {
    btcButton.addEventListener("click", () => {
      // Pw
      const btcPassword = document.querySelector("[data-password]").getAttribute("data-password");
      const passTyped = userPassword.value;

      if (passTyped === null || passTyped === "") {
        formError.classList.remove("d-b");
        formError.classList.add("d-none");
      }

      if (passTyped == btcPassword || passTyped == btcPassword.toUpperCase() ) {
        formError.classList.remove("d-b");
        formError.classList.add("d-none");

        landingElements.forEach(element => {
          element.style.display = "none";
        });

        memberElements.forEach(element => {
          element.style.display = "block";
          window.scroll(0, 0);
        });

        saveMember();

      } else if (passTyped != btcPassword) {
        formError.classList.remove("d-none");
        formError.classList.add("d-b");
      }

      userPassword.addEventListener("focus", () => {
        formError.classList.remove("d-b");
        formError.classList.add("d-none");
      });
    });
  }


  //Exit
  if (exitButton != null) {
    exitButton.addEventListener("click", () => {
      localStorage.setItem('btcMember', false);
      sessionCheck();
      window.scroll(0, 0);
    });
  }


  //Member content
  function setClass(arr, cl) {
    arr.forEach((e) => {
      e.classList.remove(cl);
    });
  }

  btcPills.forEach((pill) => {
    pill.addEventListener("click", () => {
      setClass(btcPills, "lil-pill-selected");
      pill.classList.add("lil-pill-selected");

      btcBlocks.forEach((block) => {
        if (pill.id == block.id) {
          setClass(btcBlocks, "block-current");
          block.classList.add("block-current");
        }
      });
    });
  });
}





//Restore bottoni share
const mobileToggleSocial = document.querySelector("[data-action='toggle-social-share']");

if (mobileToggleSocial != null) {
  mobileToggleSocial.addEventListener("click", () => {
    mobileToggleSocial.classList.toggle('is-active');
    mobileToggleSocial.classList.toggle('RoundButton--secondaryState');
    mobileToggleSocial.setAttribute('aria-expanded', mobileToggleSocial.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
    mobileToggleSocial.nextElementSibling.setAttribute('aria-hidden', mobileToggleSocial.nextElementSibling.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
  });
}


//Social copy to clipboard desktop
const clipboardItems = document.querySelectorAll(".desktop-clipboard");

if (clipboardItems != null) {

  const clipboardMessage = document.getElementById("copied-message");

  clipboardItems.forEach(item => {
    item.addEventListener("click", () => {
      const copyText = document.getElementById("desktop-url-to-copy");

      if (copyText != null) {
        navigator.clipboard
          .writeText(copyText.value)
          .then(() => {
            if (clipboardMessage != null) {
              clipboardMessage.classList.remove("d-none");

              setTimeout(() => {
                clipboardMessage.classList.add("d-none");
              }, "3000");
            }
            //alert("successfully copied");
          })
          .catch(() => {
            alert("sorry, something went wrong");
          });
      }

    });

  });
}

//Continue selling when out of stock
/*
const continueSellingButton = document.getElementById("inventory-continue");
if(continueSellingButton != null){
  continueSellingButton.disabled = false;
  continueSellingButton.innerHTML = "Add to cart";
} */

const inventoryContinue = document.getElementById("inventory-continue");
var addToCartBtn = document.querySelector('.ProductForm__AddToCart');

if (inventoryContinue != null) {
  inventoryContinue.removeAttribute('disabled');
  inventoryContinue.classList.add(addToCartBtn.getAttribute('data-use-primary-button') === 'true' ? 'Button--primary' : 'Button--secondary');
  inventoryContinue.setAttribute('data-action', 'add-to-cart');
  //inventoryContinue.innerHTML = "<span>".concat(window.languages.productFormAddToCart, "</span>");
}


//Variant Names swatches
const swatchOptionName = document.querySelectorAll(".swatch-option-name");
if (swatchOptionName != null) {
  const domainName = window.location.hostname;


  swatchOptionName.forEach(span => {
    if (span.dataset.label == "Gold Color" || span.dataset.label == "gold color" || span.dataset.label == "Gold color") {
      span.id = "gold-color-label";
    } else if (span.dataset.label == "Color" || span.dataset.label == "color") {
      span.id = "color-label";
    } else if (span.dataset.label == "Stone Color" || span.dataset.label == "Stone color" || span.dataset.label == "stone color") {
      span.id = "stone-color-label";
    } else if (span.dataset.label == "Stone Type" || span.dataset.label == "Stone type" || span.dataset.label == "stone type") {
      span.id = "stone-type-label";
    }
  });


  const goldSwatches = [];
  const stoneSwatches = [];
  const colorSwatches = [];
  const typeSwatches = [];
  const allSwatches = document.querySelectorAll(".icon-variant");

  function removeWeglotSwatches() {
    const weglotSwatches = document.querySelectorAll(".ProductForm__Label span[data-wg-splitted]");
    weglotSwatches.forEach((trad) => {
      trad.style.display = "none";
    });
  }


  allSwatches.forEach(swatch => {
    if (swatch.dataset.label == "Gold Color" || swatch.dataset.label == "gold color" || swatch.dataset.label == "Gold color") {
      goldSwatches.push(swatch);
    } else if (swatch.dataset.label == "Color" || swatch.dataset.label == "color") {
      colorSwatches.push(swatch);
    } else if (swatch.dataset.label == "Stone Color" || swatch.dataset.label == "Stone color" || swatch.dataset.label == "stone color") {
      stoneSwatches.push(swatch);
    } else if (swatch.dataset.label == "Stone Type" || swatch.dataset.label == "Stone type" || swatch.dataset.label == "stone type") {
      typeSwatches.push(swatch);
    }
  });

  goldSwatches.forEach(swatch => {
    swatch.addEventListener("click", () => {
      let itGoldSwatch = "";

      const goldLabel = document.getElementById("gold-color-label");
      if (goldLabel != null) {
        if (window.location.hostname === "it.lilmilan.com") {
          if (swatch.dataset.value == "Yellow" || swatch.dataset.value == "yellow") {
            itGoldSwatch = "Giallo";
          } else if (swatch.dataset.value == "White" || swatch.dataset.value == "white") {
            itGoldSwatch = "Bianco";
          }
          goldLabel.innerHTML = "- " + itGoldSwatch;
          removeWeglotSwatches();
        } else {
          goldLabel.innerHTML = "- " + swatch.dataset.value;
        }
      }

    });
  });


  colorSwatches.forEach(swatch => {
    swatch.addEventListener("click", () => {
      let itColorSwatch = "";
      const colorLabel = document.getElementById("color-label");
      if (colorLabel != null) {
        if (window.location.hostname === "it.lilmilan.com") {
          if (swatch.dataset.value == "Yellow" || swatch.dataset.value == "yellow") {
            itColorSwatch = "Giallo";
          } else if (swatch.dataset.value == "White" || swatch.dataset.value == "white") {
            itColorSwatch = "Bianco";
          } else if (swatch.dataset.value == "Pink" || swatch.dataset.value == "pink") {
            itColorSwatch = "Rosa";
          } else if (swatch.dataset.value == "Green" || swatch.dataset.value == "green") {
            itColorSwatch = "Verde";
          } else if (swatch.dataset.value == "Black" || swatch.dataset.value == "black") {
            itColorSwatch = "Nero";
          } else if (swatch.dataset.value == "Navy" || swatch.dataset.value == "navy") {
            itColorSwatch = "Navy";
          } else if (swatch.dataset.value == "Black Ink" || swatch.dataset.value == "black ink") {
            itColorSwatch = "Black Ink";
          } else if (swatch.dataset.value == "Fizzy Lime") {
            itColorSwatch = "Fizzy Lime";
          } else if (swatch.dataset.value == "Grease Pink") {
            itColorSwatch = "Grease Pink";
          } else if (swatch.dataset.value == "Mediterranean Blue") {
            itColorSwatch = "Mediterranean Blue";
          } else if (swatch.dataset.value == "Pearl" || swatch.dataset.value == "perla" ) {
            itColorSwatch = "Perla";
          } else if (swatch.dataset.value == "Gold" || swatch.dataset.value == "oro" ) {
            itColorSwatch = "Oro";
          }

          colorLabel.innerHTML = "- " + itColorSwatch;
          removeWeglotSwatches();
        } else {
          colorLabel.innerHTML = "- " + swatch.dataset.value;
        }
      }
    });
  });

  stoneSwatches.forEach(swatch => {
    swatch.addEventListener("click", () => {
      let itStoneSwatch = "";
      const stoneColorLabel = document.getElementById("stone-color-label");
      if (stoneColorLabel != null) {

        if (window.location.hostname === "it.lilmilan.com") {
          if (swatch.dataset.value == "Yellow" || swatch.dataset.value == "yellow") {
            itStoneSwatch = "Giallo";
          } else if (swatch.dataset.value == "White" || swatch.dataset.value == "white") {
            itStoneSwatch = "Bianco";
          } else if (swatch.dataset.value == "None" || swatch.dataset.value == "none") {
            itStoneSwatch = "Nessuno";
          } else if (swatch.dataset.value == "Pink" || swatch.dataset.value == "pink") {
            itStoneSwatch = "Rosa";
          } else if (swatch.dataset.value == "Red" || swatch.dataset.value == "red") {
            itStoneSwatch = "Rosso";
          } else if (swatch.dataset.value == "Green" || swatch.dataset.value == "green") {
            itStoneSwatch = "Verde";
          } else if (swatch.dataset.value == "Pearl" || swatch.dataset.value == "pearl") {
            itStoneSwatch = "Perla";
          } else if (swatch.dataset.value == "Multicolor" || swatch.dataset.value == "multicolor") {
            itStoneSwatch = "Multicolor";
          } else if (swatch.dataset.value == "Champagne" || swatch.dataset.value == "champagne") {
            itStoneSwatch = "Champagne";
          } else if (swatch.dataset.value == "Champagne" || swatch.dataset.value == "champagne") {
            itStoneSwatch = "Champagne";
          } else if (swatch.dataset.value == "Black" || swatch.dataset.value == "black") {
            itStoneSwatch = "Nero";
          } else if (swatch.dataset.value == "Fucsia" || swatch.dataset.value == "fucsia") {
            itStoneSwatch = "Fucsia";
          } else if (swatch.dataset.value == "Green Olive") {
            itStoneSwatch = "Verde Oliva";
          } else if (swatch.dataset.value == "Turquoise") {
            itStoneSwatch = "Turchese";
          }

          stoneColorLabel.innerHTML = "- " + itStoneSwatch;
          removeWeglotSwatches();
        } else {
          stoneColorLabel.innerHTML = "- " + swatch.dataset.value;
        }
      }
    });
  });


  typeSwatches.forEach(swatch => {
    swatch.addEventListener("click", () => {
      let itTypeSwatch = "";

      const typeLabel = document.getElementById("stone-type-label");
      if (typeLabel != null) {
        if (window.location.hostname === "it.lilmilan.com") {
          if (swatch.dataset.value == "Cubic Zirconia" || swatch.dataset.value == "cubic zirconia") {
            itTypeSwatch = "Zircone";
          } else if (swatch.dataset.value == "Lab grown diamond" || swatch.dataset.value == "lab grown diamond") {
            itTypeSwatch = "Diamante coltivato in laboratorio";
          }
          typeLabel.innerHTML = "- " + itTypeSwatch;
          removeWeglotSwatches();
        } else {
          typeLabel.innerHTML = "- " + swatch.dataset.value;
        }
      }

    });
  });
}